<div id="calendar-day-header">
  <i (click)="previousDay()" [nimbusIcon]="ICONS.CHEVRON_LEFT"></i>
  <div (click)="onToday()" id="today">{{ TranslationKeys.GeneralToday | translate }}</div>
  <i (click)="nextDay()" [nimbusIcon]="ICONS.CHEVRON_RIGHT"></i>
</div>
<div id="selected-day">
  <span>{{ selectedDate | dateFormat: 'ddd, L' }}</span>
</div>
